<template>
	<div class="tabulation">
		<el-card class="chart-card">
			<div class="summation">
				<div class="hint">统计 : {{ tableData.length }}条</div>
			</div>
			<div class="feature-btn">
				<el-button style="margin-left: 10px" type="primary" size="default"
					@click="add = true"><el-icon class="cancelgu">
						<Plus />
					</el-icon>添加</el-button>
			</div>

			<el-table ref="tableRef" v-loading="tableLoading" :data="tableData" style="width: 100%" row-key="unionId" height="calc(100vh - 220px)"
				border scrollbar-always-on :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts">
				<el-table-column label="会员姓名" prop="name" align="center" :show-overflow-tooltip="true" />
				<el-table-column label="会员编码" prop="userName" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column label="所属工会" prop="unionNme" align="center" :formatter="quantum"
					:show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column label="所属部门" prop="departmentName" align="center" :formatter="quantum"
					:show-overflow-tooltip="true">
				</el-table-column>
				<!-- <el-table-column label="操作" align="center" width="240">
					<template #default="scope">
						<el-button type="danger" link @click="expurgate(scope.row.userId)"><el-icon
								class="cancel">
								<Delete />
							</el-icon>删除</el-button>
					</template>
				</el-table-column> -->
			</el-table>
		</el-card>

		<!-- 添加按钮弹窗 -->
		<el-dialog v-model="add" title="管理员添加" width="500px" custom-class="system-admin-add-dialog">
			<el-form ref="ruleFormRef" :model="form" :rules="rules" class="demo-ruleForm" :size="formSize" status-icon
			>
				<!-- 填写会员编码 -->
				<el-form-item label="会员编码" prop="name">
					<el-input v-model="form.name" placeholder="请填写会员编码" size="large"></el-input>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="reset">取消</el-button>
					<el-button type="primary" :loading="loa" @click="onSubmit">确定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script>
	import {
		Delete,
		EditPen,
		Plus
	} from "@element-plus/icons-vue";
	import {
		useRouter,
		useRoute
	} from "vue-router";
	import {
		onMounted,
		ref,
		onActivated,
			reactive,
			nextTick,
	} from "vue";
	// import {tissue,Deletezz,SZargur,SZglur} from '../../utils/api'
	import {
		SZglur,
		SZargur,
		SCdelet
	} from "../../utils/api";
	import {
		ElMessage,
		ElMessageBox
	} from "element-plus";
	import qs from "qs";
	import {
		useStore
	} from "vuex";
	export default {
		name: "SZargur",

		setup() {
			const tableLoading = ref(true)
			const tableRef = ref(null)
			const refreshTableLayout = () => nextTick(() => tableRef.value?.doLayout?.())
			// 是否刷新数据
			const route = useRoute();
			let translate = ref(2);
			onActivated(() => {
				translate.value = route.params.UserId;
				if (translate.value == 1) {
					tiss();
				}
			});

			let add = ref(false);

			// 删除按钮
			const affirm = () => {
				let data = {
					unionId: sessionStorage.getItem('processIds'),
					userId: ids.value,
				};
				SCdelet(qs.stringify(data)).then((res) => {
					console.log(res.data.unionList, "77777");
					if (res.data.code == 0) {
						ElMessage({
							message: "删除成功",
							type: "success",
							center: true,
						});
						remove.value = false;
						tiss();
					} else {
						ElMessage({
							message: res.data.msg,
							type: "warning",
							center: true,
						});
						remove.value = false;
						tiss();
					}
				});
			};
			let ids = ref("");
			const expurgate = (id) => {
				ids.value = id;
				ElMessageBox.confirm('您确定要删除此管理员吗？', '管理员删除', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					affirm();
				}).catch(() => {});
			};
			let remove = ref(false);
			let quantum = (row, column, cellValue) => {
				return cellValue.slice(0, 11);
			};

			// 组织管理列表内容
			let texts = ref("加载中");
			let tableData = ref([]);

			// 管理员列表接口
			const tiss = () => {
				tableLoading.value = true
				let data = {
					// unionId:1,
					unionId: sessionStorage.getItem('processIds'),
				};
				SZargur(qs.stringify(data)).then((res) => {
					// console.log(res.data.data.adminList, "8888888888");
					// console.log(res)
					// translate.value = 2;
					tableData.value = res.data.data.adminList;
					// console.log(tableData.value, "1111");

					texts.value = tableData.value.length ? '' : '暂无数据'
				}).finally(() => {
					tableLoading.value = false
					refreshTableLayout()
				});
			};
			onMounted(() => {
				tiss();
			});

			const loa = ref(false);
			const reset = () => {
				add.value = !add.value;
				loa.value = false;
				ruleFormRef.value.resetFields();
			};
			// 表单内容
			const ruleFormRef = ref(null);
			const visible = ref(false);
			const form = reactive({
				name: "",
			});
			// 表单校验
			const onSubmit = () => {
				// 校验成功后要调用添加接口
				ruleFormRef.value.validate(async (valid) => {
					// console.log("-----------", valid);
					if (valid == true) {
						loa.value = true;
						let data = {
							unionId: sessionStorage.getItem('processIds'),
							userName: form.name,
						};
						SZglur(qs.stringify(data)).then((res) => {
							// console.log(res,"0000000")
							if (res.data.code == 0) {
								loa.value = false;
								form.name = "";
								add.value = false;
								ElMessage({
									message: "添加成功",
									type: "success",
									center: true,
								});
								tiss();
							} else {
								loa.value = false;
								form.name = "";
								add.value = false;
								loa.value = false;
								ElMessage.error(res.data.msg);

							}
						});
					} else {
						loa.value = false;
					}

					console.log(form);
				});
			};

			// 验证表单提示
			const rules = {
				name: [{
					required: true,
					message: "请输入会员编码",
					trigger: "blur"
				}],
			};

			// 列表数据循环
			// const filterTableData = ref([])
			return {
				affirm,
				expurgate,
				remove,
				texts,
				quantum,
				form,
				// 循环列表数据
				// filterTableData,
				tableData,
				// 表单校验
				visible,
				rules,
				onSubmit,
				ruleFormRef,
				add,
				reset,
				loa,
				tableLoading,
				tableRef,
			};
		},
		components: {
			Delete,
			EditPen,
			Plus,
		},
	};
</script>
<style lang="scss" scoped>
	.chart-card {
		height: calc(100vh - 145px);
	}

	::v-deep .el-table__empty-block {
		border-bottom: 1px solid #ebeef5 !important;
	}

	::v-deep .el-table__body {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}

	::v-deep .el-table__header {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}

	.hunt {
		width: 36.5%;
	}

	.el-form-item {
		display: flex;
		--font-size: 14px;
		margin-bottom: 0;
	}

	.el-form-item .el-button {
		margin-left: 75px;
	}

	.summation {
		width: 100%;
		display: flex;
		align-items: baseline;
		margin-top: 20px;
	}

	.hint {
		font-size: 14px;
		color: #909399;
	}

	.feature-btn {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		margin: 15px 0;
	}

	.el-table__header {
		margin-top: 0;
		margin-bottom: 0;
	}

	.red {
		color: red;
		border: none;
		--el-button-bg-color: none;
		--el-button-hover-bg-color: none;
		--el-button-hover-text-color: none;
	}

	.red:hover {
		color: #fab6b6;
	}

	.bulur {
		color: #409eff;
		border: none;
		--el-button-bg-color: none;
		--el-button-hover-bg-color: none;
		--el-button-hover-text-color: none;
	}

	.bulur:hover {
		color: #a0cfff;
	}

	// .el-button{
	//   border: none;
	//   --el-button-bg-color:none;
	//   --el-button-hover-bg-color:none;
	//   --el-button-hover-text-color:none;
	// }
	.el-scrollbar__thumb {
		background-color: #ffffff;
	}

	.items {
		display: flex;
	}

	.el-select .el-input__inner {
		width: 183px;
	}

	::v-deep .el-dialog--center .el-dialog__body {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	::v-deep .el-select-dropdown__empty {
		display: none !important;
	}

	.el-select-dropdown__item {
		background-color: #ffffff;
		height: 40px !important;
	}

	.el-select-dropdown__item {
		overflow: visible;
	}

	.labor {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
	}

	::v-deep .el-input--small .el-input__inner {
		height: 30px;
		line-height: 30px;
	}

	.tianjia {
		margin-left: 20px;
	}

	.cancel {
		margin-right: 5px;
		font-weight: 400;
	}

	.cancelgu {
		margin-right: 6px;
		font-weight: bold;
	}

	::v-deep .el-table__inner-wrapper::before {
		width: 0;
	}

	::v-deep .el-table .el-table__cell {
		padding-top: 15px;
		padding-bottom: 15px;
	}

	.el-card.is-always-shadow {
		width: 95%;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
	}

	::v-deep .el-card__body {
		padding: 0;
	}

	.el-pagination {
		margin-top: 10px;
	}

	::v-deep .el-input--small .el-input__inner {
		height: 30px;
		line-height: 30px;
	}

	.tabulation {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
	}

	::v-deep .el-scrollbar__thumb {
		display: none !important;
	}
</style>
<style>
	.el-dialog.system-admin-add-dialog {
		border-radius: 4px;
	}

	.el-dialog.system-admin-add-dialog .el-dialog__header {
		margin-right: 0;
		padding: 18px 20px;
		text-align: left;
	}

	.el-dialog.system-admin-add-dialog .el-dialog__title {
		font-size: 18px;
		font-weight: 400;
	}

	.el-dialog.system-admin-add-dialog .el-dialog__body {
		padding: 0 20px 20px;
		text-align: left;
	}

	.el-dialog.system-admin-add-dialog .el-form-item {
		align-items: center;
		margin-bottom: 0;
	}

	.el-dialog.system-admin-add-dialog .el-form-item__content {
		flex: 1;
	}

	.el-dialog.system-admin-add-dialog .el-input {
		width: 50%;
	}

	.el-dialog.system-admin-add-dialog .el-dialog__footer {
		margin-top: 0;
		padding: 0 20px 16px;
		text-align: right;
	}

	.el-dialog.system-admin-add-dialog .el-button {
		min-width: 78px;
		height: 32px;
	}

	.el-popper {
		z-index: 10000 !important;
	}

	.modality {
		height: 150px !important;
	}

	/* .el-scrollbar__thumb {
  display: none !important;
} */
	.el-select-dropdown__item.selected {
		font-weight: 500 !important;
	}
</style>
